export enum RolesEnum {
	DM = 'DM',
	FM = 'FM',
	IS = 'IS',
	RM = 'RM',
	RMM = 'RMM',
	TC = 'TC',
	TSM = 'TSM',
	TRS = 'TRS'
}